module.exports = __webpack_public_path__ + "static/lucas-4c936c0d7bba19aa7881aed7ea0e4b64.png";